import { render, staticRenderFns } from "./outbound-manage.vue?vue&type=template&id=4958964c&scoped=true&"
import script from "./outbound-manage.vue?vue&type=script&lang=js&"
export * from "./outbound-manage.vue?vue&type=script&lang=js&"
import style0 from "./outbound-manage.vue?vue&type=style&index=0&id=4958964c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4958964c",
  null
  
)

export default component.exports